import PropTypes from 'prop-types';

import React from 'react';

import getImageStyle from '../../../utils/getImageStyle';

import Avatar from '../../ui/Avatar';
import MediaButton from '../../ui/MediaButton';
import MediaIcon from '../../ui/MediaIcon';
import StyledDropzone from '../../ui/StyledDropzone';

export default class QuoteImage extends React.PureComponent {
  static propTypes = {
    src: PropTypes.string,
    colorScheme: PropTypes.string,

    onDropFile: PropTypes.func,
    onRemoveImage: PropTypes.func,
  };

  render() {
    const {
      src,
      colorScheme,
      onDropFile,
      onRemoveImage,
    } = this.props;

    return (
      <Avatar
        colorScheme={colorScheme}
        src={src && getImageStyle(src, '130x130')}
      >
        {
          src && (
            <div>
              <MediaButton
                position="topAvatar"
                onClick={onRemoveImage}
              >
                <MediaIcon type="remove" />
              </MediaButton>
            </div>
          )
        }
        {
          !src && (
            <StyledDropzone
              className="avatarImageDropZone"
              accept="image/*"
              multiple={false}
              minSize={100}
              maxSize={10 * 1024 * 1024}
              onDrop={onDropFile}
            >
              <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.412 16.588V10h-2.824v6.588H10v2.824h6.588V26h2.824v-6.588H26v-2.824h-6.588zM0 2C0 .895.89 0 2 0h32c1.105 0 2 .89 2 2v32c0 1.105-.89 2-2 2H2c-1.105 0-2-.89-2-2V2zm2.483.483h31.034v31.034H2.483V2.483zM33.52 4H36v4h-2.48V4zm0 8H36v4h-2.48v-4zm0 8H36v4h-2.48v-4zm0 8H36v4h-2.48v-4zM0 4h2.48v4H0V4zm0 8h2.48v4H0v-4zm0 8h2.48v4H0v-4zm0 8h2.48v4H0v-4zm32 5.52V36h-4v-2.48h4zm-8 0V36h-4v-2.48h4zm-8 0V36h-4v-2.48h4zm-8 0V36H4v-2.48h4zM32 0v2.48h-4V0h4zm-8 0v2.48h-4V0h4zm-8 0v2.48h-4V0h4zM8 0v2.48H4V0h4z" fill="#CBCBCB" fillRule="evenodd" />
              </svg>
            </StyledDropzone>
          )
        }
      </Avatar>
    );
  }
}
